<template>
  <!-- <b-navbar toggleable="md" fixed="top" type="dark" variant="dark"> -->
  <b-navbar toggleable="md" fixed="top"  class="a">
    <b-container>
      <b-navbar-brand :to="{name: 'home'}">VectorByte</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
         
          <b-nav-item-dropdown text="Databases" toggle-class="nav-link-custom" left :no-caret="false">
            <b-dropdown-item :to="{name: 'vecdyn'}">VecDyn</b-dropdown-item>
            <b-dropdown-item :to="{name: 'vectraits'}">VecTraits</b-dropdown-item>
            <b-dropdown-item href="https://www.vectorbyte.org/vecdataecosystem">VectorData Ecosystem</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="https://vectorbitedataplatform.readthedocs.io/en/latest/">Documentation</b-nav-item>
          <b-nav-item-dropdown text="Contact Us" toggle-class="nav-link-custom" left>
            <b-dropdown-item :to="{name: 'report-problem'}">Report problem</b-dropdown-item>
            <b-dropdown-item :to="{name: 'enquiries'}">General enquiries</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Vectorbyte1" toggle-class="nav-link-custom" left>
            <b-dropdown-item :to="{name: 'team'}">Meet the team</b-dropdown-item>
            <b-dropdown-item :to="{name: 'about'}">About</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown right :no-caret="true" v-if="user.username">
            <template slot="button-content">
              <i class="fas fa-user-circle tw-text-2xl"></i>
            </template>
            <b-dropdown-item :to="{name: 'user'}">Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{name: 'dashboard'}">Data Portal</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right :no-caret="true" v-else>
            <template slot="button-content">
              <i class="fas fa-user-circle tw-text-2xl"></i>
            </template>
            <b-dropdown-item :to="{name: 'login', query: { next: currentPage }}">Sign In</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="redirectToSignUp()">Sign Up</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as _ from "lodash";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    admin_authorized : function() {
      const that = this;
      // store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])
      let groups = ['admin', 'uploader', 'collaborator'];
      return Boolean((_.intersection(that.myGroups, groups)).length);
    },
    currentPage : function() {
      return window.location.pathname;
    } 
  },
  methods: {
    ...mapActions([
      "setBaseComponent",
      "clearAuthorizationToken",
    ]),
    ...mapActions("user", ["setUser", "setMyGroups"]),
    goTo(route) {
      this.$router.push(route);
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});
      this.setMyGroups([]);

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      // this.$router.push({
      //   // name: "home"
      //   path: '/legacy-databases-home/'
      // });
    },
    redirectToSignUp() {
      window.location.href = `${process.env.VUE_APP_AXIOS_BASE_URL}/accounts/signup/`;
    },
  }
};
</script>

<style>
  .a {
    background-color: #F7F7F7 !important;
  }

  .dropdown-toggle::after {
    /* I had to add the following 4 rules to override whatever was causing the
    caret to be displayed in the middle of the label */
    display: inline-block !important;
    position: relative !important;
    right: 0 !important;
    top: 0 !important;
    /* ------ */
    width: 0;
    height: 0;
    margin-left: .3em;
    vertical-align: middle;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-left: .3em solid transparent;
    list-style: none;
}
</style>